'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = _propTypes2.default.shape({
  /** The value for that field */
  value: _propTypes2.default.any,

  /** i18n code for the error this value is presenting */
  error: _propTypes2.default.string,

  /** Whether the input should receive focus */
  focus: _propTypes2.default.bool,

  /** Whether the input has already been touched by the user */
  touched: _propTypes2.default.bool
});
module.exports = exports['default'];